import { useSession, signIn, signOut } from 'next-auth/react'
import { useCallback } from 'react'

export function useNextAuth() {
  const { data: session, status } = useSession()

  const isLoading = status === 'loading'
  const isFacebookConnected = status === 'authenticated' && session?.user?.provider === 'facebook'
  const facebookUser = isFacebookConnected ? session?.user : null

  const connectFacebook = useCallback(async () => {
    try {
      console.log('🔄 useNextAuth Hook: Starting Facebook connection');
      console.log('📝 Connection context:', {
        currentStatus: status,
        isCurrentlyConnected: isFacebookConnected,
        hasSession: !!session,
        timestamp: new Date().toISOString()
      });
      
      // const result = await signIn('facebook', { redirect: false })
      
      console.log('📊 SignIn result:', {
        success: !result?.error,
        error: result?.error || null,
        url: result?.url || null,
        status: result?.status || null,
        timestamp: new Date().toISOString()
      });
      
      if (result?.error) {
        console.error('❌ useNextAuth Hook: SignIn returned error:', result.error);
        throw new Error(result.error)
      }
      
      console.log('✅ useNextAuth Hook: Facebook connection initiated successfully');
    } catch (error) {
      console.error('❌ useNextAuth Hook: Facebook connection failed:', error);
      console.error('🔍 Connection error details:', {
        error: error instanceof Error ? error.message : String(error),
        stack: error instanceof Error ? error.stack : undefined,
        currentStatus: status,
        timestamp: new Date().toISOString()
      });
      throw error
    }
  }, [status, isFacebookConnected, session])

  const disconnectFacebook = useCallback(async () => {
    try {
      console.log('🔄 useNextAuth Hook: Starting Facebook disconnection');
      console.log('📝 Disconnection context:', {
        currentStatus: status,
        isCurrentlyConnected: isFacebookConnected,
        hasSession: !!session,
        userEmail: session?.user?.email,
        timestamp: new Date().toISOString()
      });
      
      // await signOut({ redirect: false })
      
      console.log('✅ useNextAuth Hook: Facebook disconnection completed successfully');
    } catch (error) {
      console.error('❌ useNextAuth Hook: Facebook disconnection failed:', error);
      console.error('🔍 Disconnection error details:', {
        error: error instanceof Error ? error.message : String(error),
        stack: error instanceof Error ? error.stack : undefined,
        currentStatus: status,
        timestamp: new Date().toISOString()
      });
      throw error
    }
  }, [status, isFacebookConnected, session])

  return {
    facebookUser,
    session,
    isFacebookConnected,
    isLoading,
    error: null,
    connectFacebook,
    disconnectFacebook,
    user: facebookUser,
    isAuthenticated: isFacebookConnected,
    loginWithFacebook: connectFacebook,
    logout: disconnectFacebook,
  }
}
